import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import pdf from "../../Assets/Mustafa's Résumé.pdf";

function Resume() {

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
                <Resumecontent
              title="Full-Stack Web Developer"
              date="Aug 2020 - Feb 2021"
              content={[
                "Freelanced as a full stack web developer position where I built multiple websites for clients handling the frontend and backend design and development. Currently developing and maintaining an on-going e-commerce website for a newly established company named Malabsi",
                "Services / languages: AWS, Amplify, AppSync, DynamoDB, AWS Cognito, React, Next JS, Material UI, JavaScript, NoSql, SQL, Serverless architecture, AWS S3",
              ]}
            />
            <Resumecontent
              title="Intern - Geographic Information System and Mapping Lab AUS"
              date="Jun 2019 - Sept 2019"
              content={[
                "Developed a Gulf Monitor website to help facilitate students' research with visual environmental data from in the Arabian Gulf region from NASA",
              ]}
            />
            <Resumecontent
              title="IT Consultant"
              date="Aug 2017 - May 2020"
              content={[
                "Freelance Augmented reality mobile application with responsibility of designing and developing as well as handling all client requests.",
                "Handled all student’s IT related issues and side project on computed.",
                "Project: Projection of 3D objects and playing of multiple videos upon the camera detection of a real object in the environment in the library. This project is meant to guide its users in the library",
                
              ]}
            /> 
            <Resumecontent
              title="Junior Machine Learning Research"
              date="Jan 2020 - May 2020"
              content={[
                "A Lead Author of Botnet Attack Detection using Machine Learning by assembling data from Kaggle.com on Botnet Attack datasets and using varrious ML classifiers to train on the data and learn the behaviour of malicious Botnet devices.",
                "Assembled the data from various social media platforms using Twitter, Reddit.Interpreted the collected text using word-clouds and various other factors that affect the change of sentiments of youth.",
              ]}
            />  
         
           
          </Col>
          <Col md={6} className="resume-right">
           <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Web Developer [Golden Well Petro]"
              content={[
                "Created and hosted the frontend-end of the website using Bootstrap, Javascript and firebase services.",
              ]}
            />
            <Resumecontent
              title="Web Developer [Sohar Gate]"
              content={[
                "Operated on developing the frontend end of the website using Bootstrap, Javascript and backend APIs using Node.js",
              ]}
            />
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="Computer Science And Engineering [AUS, Sharjah] "
              date="2016 - 2020"
              content={["CGPA: 3.1"]}
            />
            <Resumecontent
              title="Grade 12 [Sharjah Public School, Sharjah]"
              date="2005 - 2016"
              content={["Precentage: 95%"]}
            />
      
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                `Team Manager of Computer Club AUS `,
                "Published Botnet Attack Detection using Machine Learning - Lead Author 2020",
                "Participant in Google Hackathon  2019",
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
